<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-card v-if="isAdmin">
            <v-tabs v-model="tab">
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab v-for="item in items" :key="item">
                    {{ item }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                  <TableActive :programs="programs" :employeeRole="employeeRole" :isAdmin="isAdmin" />
                </v-tab-item>
                <v-tab-item>
                  <TableInActive :programs="programs" :employeeRole="employeeRole" :isAdmin="isAdmin" />
                </v-tab-item>
            </v-tabs-items>
        </v-card>
        <TableNotAdmin :programs="programs" :employeeRole="employeeRole" :isAdmin="isAdmin"/>
        <Foot/>
    </div>
</template>

<script>

import axios from 'axios'
import Foot from "../../components/Footer.vue"
import TableActive from "./TableActive.vue"
import TableInActive from "./TableInActive.vue"
import TableNotAdmin from './TableNotAdmin.vue'
import moment from 'moment'
import {mapActions, mapState} from "vuex";
import Swal from 'sweetalert2'

const url = require("../../client_config/config").url;

export default {
    components: {
      Foot,
      TableActive,
      TableInActive,
      TableNotAdmin
    },
    data: function () {
        return {
            headers: [
                {
                    text: 'Select Staff',
                    align: 'start',
                    sortable: false,
                    value: 'select',
                },
                {text: "Name", value: "Name"},
                {text: "Phone", value: "PhoneNumber"},
                {text: "Email", value: "Email"},
                // { text: "Address", value: "Address" },
                // { text: "City", value: "City" },
                {text: "State", value: "State"},
                // { text: "Zip", value: "Zip" },
                {text: "Position", value: "Role"},
                {text: "Status", value: "Status"},
                {text: "Program", value: "Program"},
                {text: "Progress", value: "Progress"},
                {text: "Verification Status", value: "VerificationStatus"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            tab: null,
            items: ["Active Staff", "Former Staff"],
            date: null,
            menu: false,
            menu1: false,
            birthMenu: false,
            anniversaryMenu: false,
            activePicker: null,
            birthDate: null,
            anniversaryDate: null,
            administration: false,
            directCareStaff: false,
            assistantManager: false,
            houseManager: false,
            programManager: false,
            humanResources: false,
            clientServicesManager: false,
            programCoordinator: false,
            executiveDirector: false,
            financeManager: false,
            complianceManager: false,
            parentGuardian: false,
            supportCoordinator: false,
            client: false,
            adddialog: false,
            editdialog: false,
            passdialog: false,
            editEmail: false,
            editEmployee: false,
            newEmployee: false,
            msg: false,
            search: "",
            text: "",
            position: ["Admin", "House Manager", "Assistant Manager", "Direct Care Staff"],
            estatus: ["Full-Time", "Part-Time"],
            employees: [],
            users: [],
            usersResult: [],
            employeeRole: "",
            staffID: "",
            titleForm: "New Staff",
            employeeID: "",
            newName: "",
            newPassword: "",
            newRePass: "",
            newPhone: "",
            newPhoneCarrier: "",
            newDate: "",
            newRole: "",
            newProgram: "",
            newSecurityQuestion: "",
            newEmail: "",
            newAddress: "",
            newCity: "",
            newState: "",
            newZip: "",
            newPosition: "",
            newStatus: "",
            birthday: "",
            anniversary: "",
            Role: localStorage.getItem('userRole'),
            editedIndex: -1,
            programs: [],
            userState: localStorage.getItem('userState'),
            former: [],
            temp: [],
            editedItem: {
                name: "",
                phone: "",
                email: "",
                address: "",
                city: "",
                state: "",
                zip: "",
                position: "",
                status: "",
            },
            defaultItem: {
                name: "",
                phone: "",
                email: "",
                address: "",
                city: "",
                state: "",
                zip: "",
                position: "",
                status: "",
            },
            page: 1,
            pageCount: 1,
            itemCount: 0,
            options: {},
            isLoading: true,
            requiredField: [
                v => !!v || 'This is required',
            ],
            emailRules: [
                v => !!v || 'This is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
        };
    },

    computed: {
        ...mapState({
            droles: 'userRoles',
        }),

        formTitle() {
            return this.editedIndex != 1 ? "New Item" : "Edit Item";
        },
        isAdmin() {
            let roles = [
                "Administration",
                "Human Resources",
                "Program Coordinator",
                "Compliance Manager",
                "Client Services Manager",
                "Medical Manager",
                "Program Manager",
                "SuperAdministrator"
            ]
            return roles.includes(localStorage.getItem('userRole'))
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        birthMenu(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
        anniversaryMenu(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },

        options: {
            handler() {
                this.getPrograms();
            },
            deep: true
        }

    },

    async created() {
      await this.getEmployeesStatus();
      this.getPrograms();
    },

    methods: {

        ...mapActions({
            downloadCSV: "users/downloadCSV",
        }),

        getColor(sts) {
            if (sts == "New") return 'green'
            else if (sts == "Prospect") return 'orange'
            else if (sts == "Negotion") return 'blue'
            else return 'teal'
        },
        validate() {
            return this.$refs.form.validate()
        },
        initialize() {
            this.employees = [];
        },

        async getEmployeesStatus(){
          if (localStorage.getItem('userRole') === "Direct Care Staff"
              || localStorage.getItem('userRole') === "Assistant Manager"
              || localStorage.getItem('userRole') === "Shift Lead"
              || localStorage.getItem('userRole') === "House Manager"
              || localStorage.getItem('userRole') === "Finance Manager"
              || localStorage.getItem('userRole') === "Client"
              || localStorage.getItem('userRole') === "Support Coordinator"
              || localStorage.getItem('userRole') === "Parent/Guardian"
          ) {
            this.employeeRole = "NotAdmin";
          } else if (localStorage.getItem('userRole') === "Program Coordinator" ||
              localStorage.getItem('userRole') === "Medical Manager" ||
              localStorage.getItem('userRole') === "Program Manager" ||
              localStorage.getItem('userRole') === "Client Services Manager" ||
              localStorage.getItem('userRole') === "Human Resources" ||
              localStorage.getItem('userRole') === "Program Coordinator" ||
              localStorage.getItem('userRole') === "Compliance Manager"
          ) {
              this.employeeRole = "AdminState";
          } else if (localStorage.getItem('userRole') === "Administration" ) {
              this.employeeRole = "Admin";
          } else if (localStorage.getItem('userRole') === "SuperAdministrator") {
              this.employeeRole = "SuperAdmin";
          } else {
             this.employeeRole = "NotAdminState";
          }
        },

        viewEmployee(item) {
            this.titleForm = "Viewing " + item.Name;
            this.editEmail = true
            this.editdialog = true;
            this.editEmployee = true;
            this.newEmployee = false;
            this.newName = item.Name;
            this.newPhone = item.PhoneNumber;
            this.newEmail = item.Email;
            this.newDate = item.Date !== "Invalid date" ? moment(item.Date).format("YYYY-MM-DD") : '';
            this.newAddress = item.Address;
            this.newCity = item.City;
            this.newState = item.State;
            this.newZip = item.Zip;
            this.newPosition = item.Position;
            this.newStatus = item.Status;
            this.newRole = item.Role;
            this.newPhoneCarrier = item.PhoneCarrier;
            this.newProgram = item.Program;
            this.employeeID = item._id;
            this.birthDate = this.checkDate(item.BirthDate);
            this.anniversaryDate = item.AnniversaryDate;
        },

        //unused function
        // getStaffID(item) {
        //   this.employeeID = item._id;
        //   window.localStorage.setItem('staffId', this.employeeID)
        // },

        showAdd() {
            this.titleForm = "New Staff";
            this.newEmployee = true;
            this.adddialog = true;
            this.editEmployee = false;
            this.newName = "";
            this.newEmail = "";
            this.newPassword = "";
            this.newRePass = "";
            this.newRole = "Client";
            this.newDate = "";
            this.newProgram = "";
            this.newPhone = "";
            this.newPhoneCarrier = "";
            this.newAddress = "";
            this.newCity = "";
            this.newState = "";
            this.newZip = "";
            this.newPosition = "";
            this.newStatus = "";
            this.newSecurityQuestion = "";
        },

        deleteEmployee(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this staff?") &&
            this.employeeDelete(id);

        },

        employeeDelete(id) {
            axios.delete(`${url}/employees/${id}`)
                .then((response) => {
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            this.msg = true;
                            this.text = data.msg;
                        });
                    }
                    this.msg = true;
                    this.text = "The staff has been deleted successfully.";
                    this.getEmployees();
                });
        },

        close() {
            this.adddialog = false;
            this.editdialog = false;
            this.passdialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        updateEmployee() {
            var req_body = {
                Name: this.newName,
                PhoneNumber: this.newPhone,
                PhoneCarrier: this.newPhoneCarrier,
                Role: this.newRole,
                Program: this.newProgram,
                Email: this.newEmail,
                BirthDate: this.birthDate,
                AnniversaryDate: this.anniversaryDate,
                Date: this.newDate,
                Address: this.newAddress,
                City: this.newCity,
                State: this.newState,
                Zip: this.newZip,
                Position: this.newPosition,
                Status: this.newStatus,
                SecurityQuestion: this.newSecurityQuestion,
            };
            axios.put(`${url}/employees/${this.employeeID}`, req_body).then((response) => {
                this.getEmployees();
                if (response.status === 400) {
                    response.json().then(function (data) {
                        alert(data.msg);
                    });
                }
                this.newName = "";
                this.newEmail = "";
                this.newDate = "";
                this.newPassword = "";
                this.newRePass = "";
                this.newRole = "";
                this.newDate = "";
                this.birthDate = "";
                this.anniversaryDate = "";
                this.newProgram = "";
                this.newPhone = "";
                this.newPhoneCarrier = "";
                this.newAddress = "";
                this.newCity = "";
                this.newState = "";
                this.newZip = "";
                this.newPosition = "";
                this.newStatus = "";
                this.newSecurityQuestion = "";
                this.msg = true;
                this.text = "The staff has been updated successfully.";
            });
            this.close();
        },


        addEmployee: function () {
            var req_body = {
                Name: this.newName,
                Email: this.newEmail,
                Password: this.newPassword,
                Role: this.newRoleClient,
                Date: this.newDate,
                Program: this.newProgram,
                Phone: this.newPhone,
                PhoneCarrier: this.newPhoneCarrier,
                Address: this.newAddress,
                City: this.newCity,
                State: this.newState,
                Zip: this.newZip,
                Position: this.newPosition,
                Status: this.newStatus,
                SecurityQuestion: this.newSecurityQuestion,
            };

            axios.post(`${url}/employees`, req_body).then(res => {
                this.getEmployees();
                if (res.status == 400) {
                    res.json().then(function (data) {
                        this.text = data.msg;
                    });
                }
                this.newName = "";
                this.newEmail = "";
                this.newPassword = "";
                this.newRePass = "";
                this.newRole = "";
                this.newDate = "";
                this.newProgram = "";
                this.newPhone = "";
                this.newPhoneCarrier = "";
                this.newAddress = "";
                this.newCity = "";
                this.newState = "";
                this.newZip = "";
                this.newPosition = "";
                this.newStatus = "";
                this.newSecurityQuestion = "";
                this.msg = true;
                this.text = "The new staff has been added successfully.";
            });
            this.close();
        },

        changePassword(item) {
            this.passdialog = true;
            this.employeeID = item._id;
        },

        updatePassword: function () {
            if (this.validate()) {
                if (this.newPassword == this.newRePass) {
                    var req_body = {
                        Password: this.newPassword
                    };
                    axios.put(`${url}/users/${this.employeeID}`, req_body).then((response) => {
                        if (response.status == 400) {
                            response.json().then(function (data) {
                                this.msg = true;
                                this.text = data.msg;
                            });
                        }
                    });
                    this.text = "The account password has been updated successfully.";
                    this.msg = true;
                    this.close();
                } else {
                    this.text = "The passwords do not match, please try again.";
                    this.msg = true;
                }
            }
        },

        async getPrograms() {
            if (localStorage.getItem('userRole') == "Administration") {
                await axios.get(`${url}/units`).then(async res => {
                    this.programs = []
                    this.programs = res.data.units
                })
            } else {
                axios.get(`${url}/units/state/${this.userState}`).then(async res => {
                    this.programs = []
                    this.programs = res.data.units
                })
            }

        },

        async download() {
           Swal.fire({
              title: 'Please wait...',
              text: 'Downloading csv...',
              icon: 'info',
              allowOutsideClick: false,
              showConfirmButton: true,
              willOpen: () => {
                Swal.showLoading();
              },
            });
            try {

                const response = await this.downloadCSV(this.userState)
                if (response.success) {
                    var FileSaver = require("file-saver");
                    const blob = new Blob([response.data], {type: "text/csv"});
                    FileSaver.saveAs(blob, response.filename);
                    return
                }
                this.msg = true;
                this.text = response.message
            } catch (error) {
                console.log(error)
                this.msg = true;
                this.text = "An Error Occured"
            }
        },

    },

};
</script>
<style>

.red-header {
    color: red;
}

* {
    text-decoration: none;
}
</style>
